// Figma component: nativeLoadingSpinner
// 8-bar radial spinner. Color defaults to currentColor (inherits from CSS),
// or pass light=true for white, or a hex string via the color prop.

export default function Spinner({ light, color, size = 24, className }) {
  const fill = color ?? (light ? '#ffffff' : 'currentColor')
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      aria-hidden="true"
      className={className}
    >
      <g>
        {[0, 45, 90, 135, 180, 225, 270, 315].map((angle, i) => (
          <rect
            key={angle}
            x="7.1" y="1"
            width="1.8" height="4.5"
            rx="0.9"
            fill={fill}
            opacity={(i + 1) / 8}
            transform={`rotate(${angle} 8 8)`}
          />
        ))}
        <animateTransform
          attributeName="transform"
          type="rotate"
          values="0 8 8;45 8 8;90 8 8;135 8 8;180 8 8;225 8 8;270 8 8;315 8 8;360 8 8"
          calcMode="discrete"
          dur="600ms"
          repeatCount="indefinite"
        />
      </g>
    </svg>
  )
}
